"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _default = {
  data: function data() {
    return {
      reqType: "insert",
      tableData: [],
      total: 0,
      currentPage: 1,
      pageLimit: 10,
      //每页请求多少个数据，默认10
      pageSizes: this.$tablePageSizes,
      loading: true,
      dialogVisible: false
    };
  },
  methods: {
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var page,
          data,
          _yield$this$req$reqPa,
          rows,
          total,
          _args = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              page = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
              data = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
              if (page == null) {
                page = this.currentPage;
              }
              this.currentPage = page;
              this.loading = true;
              if (data == null) {
                data = {};
              }
              // let data = { limit: this.pageLimit, page: page };
              data["limit"] = this.pageLimit;
              data["page"] = page;
              _context.next = 10;
              return this.req.reqPage(data);
            case 10:
              _yield$this$req$reqPa = _context.sent;
              rows = _yield$this$req$reqPa.rows;
              total = _yield$this$req$reqPa.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    clearForm: function clearForm() {
      if (this.form) {
        var obj = {};
        for (var key in this.form) {
          if (key == "state") {
            obj[key] = 1;
          } else {
            obj[key] = "";
          }
        }
        this.form = obj;
      }
    },
    handleCreate: function handleCreate() {
      this.dialogVisible = true;
      this.reqType = "insert";
      this.clearForm();
      var _this = this;
      this.$nextTick(function () {
        _this.$refs["form"].clearValidate();
      });
    },
    handleFilter: function handleFilter() {
      this.total = 1;
      this.getData(1);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageLimit = val;
      this.getData(1);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.getData(val);
    },
    handleUpdate: function handleUpdate(val) {
      this.reqType = "update";
      this.dialogVisible = true;
      console.log(val);
      this.form = val;
    },
    handleDelete: function handleDelete(val) {
      var _this2 = this;
      this.$confirm("是否删除该数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this2.req.reqDelete({
          id: val.id
        }).then(function (res) {
          if (res.code == 1) {
            _this2.$message({
              message: "删除成功",
              type: "success"
            });
            _this2.getData();
          }
        });
      }).catch(function () {
        _this2.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    handleSubmit: function () {
      var _handleSubmit = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(formName) {
        var _this3 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              console.log(this.fileList);
              this.$refs[formName].validate( /*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(valid) {
                  return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!valid) {
                          _context2.next = 13;
                          break;
                        }
                        if (!(_this3.reqType == "insert")) {
                          _context2.next = 6;
                          break;
                        }
                        _context2.next = 4;
                        return _this3.req.reqInsert(_this3.form);
                      case 4:
                        _context2.next = 9;
                        break;
                      case 6:
                        if (!(_this3.reqType == "update")) {
                          _context2.next = 9;
                          break;
                        }
                        _context2.next = 9;
                        return _this3.req.reqUpdate(_this3.form);
                      case 9:
                        _this3.dialogVisible = false;
                        _this3.getData(1);
                        _context2.next = 14;
                        break;
                      case 13:
                        return _context2.abrupt("return", true);
                      case 14:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x2) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleSubmit(_x) {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }()
  }
};
exports.default = _default;